import React, { useContext } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { BandsContext } from "../../../../utils/stateHandlers/contexts";

export default function BandsSpecialInstructions() {
  const { bandsDispatch } = useContext(BandsContext);
  return (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        Special Instructions
      </Typography>
      <TextField
        color="primary"
        variant="outlined"
        size="small"
        sx={{
          width: "100%",
          margin: "unset",
        }}
        onChange={(e) => {
          bandsDispatch({
            type: "setSpecialInstructions",
            payload: e.target.value,
          });
        }}
        inputProps={{
          style: {
            fontSize: 15,
            paddingBottom: 100,
          },
        }}
      />
    </Stack>
  );
}
